module.exports = "<div class=\"lui-interactive\" seedelement><span class=\"text\"><slot></slot></span>\n  <svg class=\"selected-icon\" viewBox=\"0 0 16 16\">\n    <path d=\"M15,4.45,6.78,12.71a1,1,0,0,1-1.42,0L1,8.34,2.41,6.93l3.66,3.66L13.62,3Z\"/>\n  </svg>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./packages/lui-menu/theme/lui-menuitem.html
// module id = 249
// module chunks = 0 1 3